import { SummaryHandlerProps, SummaryHandlerReturnArgs } from "../SummaryPage";
import { MediaSource } from "../../../../../../../models/media/MediaSource";
import { useRequestIntegrationTransferMutation } from "../../../../../../../store/api/kinesense";
import { SourceSelectionPageIntegrationData } from "../../../ImportWizard";

export default function useHandleIntegration(props: SummaryHandlerProps): SummaryHandlerReturnArgs | undefined {
    // Prevent misuse
    if (props.request.source.data.type != "integration") {
        throw new Error(
            `This hook should only be used when handling integration sources. Current data type: ${props.request.source.data.type}`,
        );
    }

    const { integrationMediaSource } = props.request.source.data as SourceSelectionPageIntegrationData;

    const [requestIntegrationTransfer] = useRequestIntegrationTransferMutation();

    async function setupFiles(mediaSource: MediaSource) {
        props.setUploadState("transferring");

        await requestIntegrationTransfer({
            integrationId: "overcast",
            integrationMediaId: integrationMediaSource.integrationMediaId,
            mediaId: mediaSource.mediaId,
        }).unwrap();

        return [integrationMediaSource.files.initialDisplay.fileId];
    }

    function renderSourceSummaryRow() {
        const source = "Overcast: " + integrationMediaSource.integrationMediaId;

        return (
            <tr>
                <td>Source</td>
                <td className="break" title={source}>
                    {source}
                </td>
            </tr>
        );
    }

    function renderAdditionalSummaryRows() {
        return;
    }

    function renderProgressBar() {
        return;
    }

    throw new Error("Unimplemented");
}
